import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Importar Axios para realizar la solicitud HTTP
import styles from './CreateSaleModal.module.css';

const CreateSaleModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    cerrado: {
      cierre: true,
      precioCierre: '',
      currencyCierre: 'USD',
      fecha: '',
      buyingTip: false,
      selleringTip: false,
      sellerCommision: '',
      officeComission: '',
      totalComission: '',
      franquiciaComission: '',
      martillerComission: '',
    },
    isForSale: false,
    isForRent: false,
    descripcion: '',
    linkReferencia: '',
    titulo: '',
    sellerId: null,
    martillerId:null,
  });

  const [activeSellers, setActiveSellers] = useState([]); // Estado para almacenar los vendedores activos

  // Obtener los vendedores activos al cargar el componente
  useEffect(() => {
    const fetchActiveSellers = async () => {
      try {
        const response = await axios.get('/sellers/active'); // Solicitud al endpoint
        setActiveSellers(response.data); // Guardar los vendedores activos en el estado
      } catch (error) {
        console.error('Error al obtener los vendedores activos:', error);
      }
    };

    fetchActiveSellers();
  }, []);

  // Calcular automáticamente las comisiones cuando cambien los valores relevantes
  useEffect(() => {
    const precioCierre = parseFloat(formData.cerrado.precioCierre) || 0;

    let totalComission = 0;

    if (formData.isForRent) {
      // Si es alquiler, la comisión es el valor total del inmueble por 2
      totalComission = precioCierre * 2;
      setFormData((prevData) => ({
        ...prevData,
        cerrado: {
          ...prevData.cerrado,
          buyingTip: true, // Ambas puntas se seleccionan automáticamente
          selleringTip: true,
        },
      }));
    } else {
      // Si es venta, calcular la comisión basada en las puntas
      if (formData.cerrado.buyingTip) totalComission += precioCierre * 0.03; // Punta compradora (3%)
      if (formData.cerrado.selleringTip) totalComission += precioCierre * 0.03; // Punta vendedora (3%)
    }

    // Calcular las comisiones individuales
    const sellerCommision = totalComission * 0.52; // 52%
    const martillerComission = totalComission * 0.02; // 2%
    const officeComission = totalComission * 0.38; // 38%
    const franquiciaComission = totalComission * 0.08; // 8%

    // Actualizar el estado con los valores calculados
    setFormData((prevData) => ({
      ...prevData,
      cerrado: {
        ...prevData.cerrado,
        totalComission: totalComission.toFixed(2),
        sellerCommision: sellerCommision.toFixed(2),
        martillerComission: martillerComission.toFixed(2),
        officeComission: officeComission.toFixed(2),
        franquiciaComission: franquiciaComission.toFixed(2),
      },
    }));
  }, [
    formData.cerrado.precioCierre,
    formData.cerrado.buyingTip,
    formData.cerrado.selleringTip,
    formData.isForRent,
  ]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name in formData.cerrado) {
      setFormData({
        ...formData,
        cerrado: {
          ...formData.cerrado,
          [name]: type === 'checkbox' ? checked : value,
        },
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleToggleSaleRent = (type) => {
    setFormData((prevData) => ({
      ...prevData,
      isForSale: type === 'sale',
      isForRent: type === 'rent',
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Realizar la solicitud POST al endpoint
      const response = await axios.post('/othersales', formData);
      console.log('Venta creada con éxito:', response.data);

      // Cerrar el modal después de un envío exitoso
      onClose();
    } catch (error) {
      console.error('Error al crear la venta:', error);
    }
  };

  if (!isOpen) return null;

  console.log({formData});
  

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          X
        </button>
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>Crear Nueva Venta</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <label>
            Título:
            <input
              type="text"
              name="titulo"
              value={formData.titulo}
              onChange={handleChange}
              className={styles.inputField}
              required
            />
          </label>
          <label>
            Descripción:
            <textarea
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              className={styles.inputField}
              required
            />
          </label>
          <label>
            Link de Referencia:
            <input
              type="text"
              name="linkReferencia"
              value={formData.linkReferencia}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <label>
            Vendido por Agente:
            <select
              name="sellerId"
              value={formData.sellerId || ''} // Mostrar vacío si es null
              onChange={handleChange}
              className={styles.inputField}
              required
            >
              <option value="">Seleccionar Vendedor</option>
              {activeSellers.map((seller) => (
                <option key={seller.id} value={seller.id}>
                  {seller.name} {seller.last_name}
                </option>
              ))}
            </select>
          </label>
          <h3>Datos de Cierre</h3>
          <label>
            Precio de Cierre:
            <input
              type="text"
              name="precioCierre"
              value={formData.cerrado.precioCierre}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <label>
            Moneda de Cierre:
            <select
              name="currencyCierre"
              value={formData.cerrado.currencyCierre}
              onChange={handleChange}
              className={styles.inputField}
            >
              <option value="USD">USD</option>
              <option value="ARG">ARG</option>
            </select>
          </label>
          <label>
            Fecha de Cierre:
            <input
              type="date"
              name="fecha"
              value={formData.cerrado.fecha}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <label>
            Punta Compradora:
            <input
              type="checkbox"
              name="buyingTip"
              checked={formData.cerrado.buyingTip}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <label>
            Punta Vendedora:
            <input
              type="checkbox"
              name="selleringTip"
              checked={formData.cerrado.selleringTip}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>

          {/* Botones Venta y Alquiler */}
          <div className={styles.toggleButtons}>
            <button
              type="button"
              className={`${styles.toggleButton} ${formData.isForSale ? styles.active : ''}`}
              onClick={() => handleToggleSaleRent('sale')}
            >
              Venta
            </button>
            <button
              type="button"
              className={`${styles.toggleButton} ${formData.isForRent ? styles.active : ''}`}
              onClick={() => handleToggleSaleRent('rent')}
            >
              Alquiler
            </button>
          </div>

          <label>
            Comisión Vendedor:
            <input
              type="text"
              name="sellerCommision"
              value={formData.cerrado.sellerCommision}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <label>
            Comisión Oficina:
            <input
              type="text"
              name="officeComission"
              value={formData.cerrado.officeComission}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <label>
            Comisión Total:
            <input
              type="text"
              name="totalComission"
              value={formData.cerrado.totalComission}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <label>
            Comisión Franquicia:
            <input
              type="text"
              name="franquiciaComission"
              value={formData.cerrado.franquiciaComission}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <label>
            Comisión Martillero:
            <input
              type="text"
              name="martillerComission"
              value={formData.cerrado.martillerComission}
              onChange={handleChange}
              className={styles.inputField}
            />
          </label>
          <button type="submit">Crear Venta</button>
        </form>
      </div>
    </div>
  );
};

export default CreateSaleModal;